import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <div className="eyebrow">Payment</div>
      <h1 className="mt-6 font-serif text-5xl text-[#1A1915] leading-tight">Cancelled.</h1>
      <p className="mt-6 text-base text-[#1A1915]">No charge was made. You can restart the checkout at any time.</p>
      <Link to="/checkout" className="btn-primary mt-10 inline-flex">Return to checkout</Link>
    </div>
  );
}
